import { render, staticRenderFns } from "./AddGroup.vue?vue&type=template&id=6bcdac4c&scoped=true&"
import script from "./AddGroup.vue?vue&type=script&lang=js&"
export * from "./AddGroup.vue?vue&type=script&lang=js&"
import style0 from "./AddGroup.vue?vue&type=style&index=0&id=6bcdac4c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcdac4c",
  null
  
)

export default component.exports